import React from "react";
import { Modal, List } from "antd";
import "./styles.css"; // Import CSS
import liveCourse from "../Assets/layout/newFilledIcons/liveCourse.svg";
import videoCourse from "../Assets/layout/newFilledIcons/videoCourse.svg";
import studyMaterial from "../Assets/layout/newFilledIcons/studyMaterial.svg";
import testSeries from "../Assets/layout/newFilledIcons/testSeries.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { CloseOutlined } from "@ant-design/icons";

const CreateCourseModal = ({ visible, onClose, setCourseTypeName, courseDashboardData, sizeOfContents, setSubscriptionModal }) => {

    const history = useHistory();
    const courseOptions = [
        courseDashboardData?.overview?.some(item => item?.overviewType == "liveCourse") && { title: "Live course", icon: liveCourse },
        courseDashboardData?.overview?.some(item => item?.overviewType == "videoResource") && { title: "Video course", icon: videoCourse },
        courseDashboardData?.overview?.some(item => item?.overviewType == "testSeries") && { title: "Test series", icon: studyMaterial },
        courseDashboardData?.overview?.some(item => item?.overviewType == "studyMaterial") && { title: "Study materials", icon: testSeries },
    ].filter(Boolean);
    return (
        <Modal open={visible} onCancel={onClose} footer={null} closable={false} className="modal-round-corner">

            <div style={{ display: 'flex', justifyContent: 'end', color: '#AEAEAE', fontSize: 16, }} onClick={onClose}><CloseOutlined style={{ cursor: 'pointer' }} /></div>
            <div className="create-course-modal-header" style={{ display: 'flex', justifyContent: 'center', fontSize: 18, color: '#191919', fontWeight: 700 }}>Create course</div>
            <div className="course-options-container">
                {courseOptions.map((option, index) => (
                    <div key={index} className="course-option"
                        onClick={() => {
                            if (option.title == "Live course") {
                                setCourseTypeName('liveCourses')

                                history.push({
                                    pathname: "/add-live-courses", state: {
                                        key: {
                                            fromSideMenu: true,
                                        }
                                    }
                                })
                            } else if (option.title == "Video course") {
                                setCourseTypeName('videoResources')
                                if (sizeOfContents?.isSubscriptionExpired || sizeOfContents?.spaceAvailable == 0) {
                                    setSubscriptionModal(true)
                                    return;
                                } else {
                                    history.push({
                                        pathname: "/add-video-resources", state: {
                                            key: {
                                                fromSideMenu: true,
                                            }
                                        }
                                    })
                                }
                            } else if (option.title == "Study materials") {
                                setCourseTypeName('studyMaterials')
                                if (sizeOfContents?.isSubscriptionExpired || sizeOfContents?.spaceAvailable == 0) {
                                    setSubscriptionModal(true)
                                    return;
                                } else {
                                    history.push({
                                        pathname: "/add-study-materials", state: {
                                            key: {
                                                fromSideMenu: true,
                                            }
                                        }
                                    })
                                }
                            } else if (option.title == "Test series") {
                                setCourseTypeName('onlineTestSeries')
                                if (sizeOfContents?.isSubscriptionExpired || sizeOfContents?.spaceAvailable == 0) {
                                    setSubscriptionModal(true)
                                    return;
                                } else {
                                    history.push({
                                        pathname: "/add-online-test-series", state: {
                                            key: {
                                                fromSideMenu: true,
                                            }
                                        }
                                    })
                                }
                            } else {
                                setCourseTypeName('liveCourses')
                                if (sizeOfContents?.isSubscriptionExpired || sizeOfContents?.spaceAvailable == 0) {
                                    setSubscriptionModal(true)
                                    return;
                                } else {
                                    history.push({
                                        pathname: "/add-live-courses", state: {
                                            key: {
                                                fromSideMenu: true,
                                            }
                                        }
                                    })
                                }
                            }

                        }}>
                        <img src={option.icon} alt={option.title} className="course-icon" />
                        <span style={{ color: '#636363', marginLeft: 15, fontSize: 16 }}>{option.title}</span>
                    </div>
                ))}
            </div>
        </Modal>
    );
};

export default CreateCourseModal;
